import { FC } from 'react'
import { LinkButton } from '@/atoms/Button'
import { CollectibleOffer, CollectibleProductPack } from '@/types/codegen-federation'
import { CollectiblesGoalTrackerBreakdown } from '../CollectiblesGoalTrackerBreakdown'
import { FrameDisplay } from '../CollectiblesPacksViews/CollectiblesPacksView'

interface CollectiblesProductCarouselItemProps {
  slug: string
  offers?: CollectibleOffer[]
}

export const CollectiblesProductCarouselItem: FC<CollectiblesProductCarouselItemProps> = ({ slug, offers }) => {
  const defaultProduct = offers?.[0]?.products?.[0] as CollectibleProductPack

  return (
    <div className="min-w-[256px] max-w-[275px] shrink-0 snap-center snap-always rounded-xl bg-white px-2 py-4 md:min-w-[360px] md:max-w-[360px]">
      <div className="mx-auto p-5">
        {defaultProduct?.images && (defaultProduct?.images?.length ?? 0) > 0 ? (
          <FrameDisplay images={defaultProduct.images.filter((image): image is string => image != null)} />
        ) : (
          <>{defaultProduct?.image && <img src={defaultProduct?.image} alt="pack" className="max-full mx-auto" />}</>
        )}
      </div>
      <LinkButton variant="black" href={`/collectibles/${slug}/shop`} className="mx-auto w-fit">
        View Packs
      </LinkButton>
      <CollectiblesGoalTrackerBreakdown slug={slug} />
    </div>
  )
}
